"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seviceHeaderWidget = exports.USAGE_TYPES = exports.TRANSLATION_MAPPING = exports.RATES_TYPES = exports.PLAN_TYPES = exports.PKG_NAME = exports.INCLUSIONS_TYPES = exports.DETAILS_SECTIONS = void 0;
var _package = require("../../package.json");
var DETAILS_SECTIONS = {
  specificationGroupKey: 'imagedFeature',
  sectionType: 'includedApps'
};
exports.DETAILS_SECTIONS = DETAILS_SECTIONS;
var seviceHeaderWidget = 'service-details-header';
exports.seviceHeaderWidget = seviceHeaderWidget;
var INCLUSIONS_TYPES = {
  SMS: 'SMS_ALLNET',
  voice: 'VOICE_ALLNET',
  internationalVoice: 'voice_international',
  data: 'DATA_NATIONAL',
  includedApps: 'includedApps'
};
exports.INCLUSIONS_TYPES = INCLUSIONS_TYPES;
var RATES_TYPES = {
  data: 'Data_Charges',
  minutes: 'VOICE_Charges',
  sms: 'SMS_Charges',
  internationalVoice: 'voice_international_Charges'
};
exports.RATES_TYPES = RATES_TYPES;
var USAGE_TYPES = {
  data: 'data',
  voice: 'national voice',
  internationalVoice: 'international voice',
  sms: 'sms'
};
exports.USAGE_TYPES = USAGE_TYPES;
var TRANSLATION_MAPPING = {
  VOICE_ALLNET: 'mins',
  DATA_NATIONAL: 'data',
  voice_international: 'internationalMins',
  SMS_ALLNET: 'sms',
  includedApps: 'free',
  VOICE_Charges: 'voiceCharge',
  SMS_Charges: 'smsCharge',
  Data_Charges: 'dataCharge',
  voice_international_Charges: 'internationalVoiceCharge'
};
exports.TRANSLATION_MAPPING = TRANSLATION_MAPPING;
var PKG_NAME = _package.name;
exports.PKG_NAME = PKG_NAME;
var PLAN_TYPES = {
  basic: 'basic',
  bundle: 'bundle'
};
exports.PLAN_TYPES = PLAN_TYPES;